import React from 'react'
import "./Footer.css"
function Footer() {
    return (
        <footer id="footer">
            <div className='leftFooter'>
                <h4>.</h4>
                <p>.</p>
            </div>

            <div className='midFooter'>
                <h1>E-COMMERCE</h1>
                <p>Qulity matters for us</p>
                <p>Copyrights 2023 &copy; Vish</p>
            </div>

            <div className='rightFooter'>
                <h4>Follow Me</h4>
                <a href='https://www.instagram.com/vishuu_5592.exe/)'>Instagram</a>
                <a href='https://www.linkedin.com/in/vishal-magdum-893166228/'>Linkdin</a>
            </div>
        </footer>
    )
}

export default Footer